/* tslint:disable */
/* eslint-disable */
export enum MessageRole {
  User = 'user',
  Assistant = 'assistant'
}
